import { Actions } from './agenceActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedId: 0
    },
    agences: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour le domaine "agence"
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {

        case Actions.FETCH_SUGGESTIONS_AGENCE_REQUEST:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case Actions.FETCH_SUGGESTIONS_AGENCE_SUCCESS:

            //let agences = action.agences.map((agence, index) => { let x = { id: index, code: agence.code, libelle: agence.libelle }; return x; });

            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.agences], isLoading: false }
            };
        case Actions.FETCH_SUGGESTIONS_AGENCE_FAILURE:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case Actions.CLEAR_SUGGESTIONS_AGENCE:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case Actions.SET_AGENCE_VALUE:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedId: action.selectedId }
            };
        case Actions.CLEAR_AGENCE_VALUE:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedId: 0 }
            };


        default:
    }

    return state;
};

export default reducer;